import { useContext } from 'react';
import { Context } from './CompanyUserContext';
export const useCompanyUserContext = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useCompanyUserContext must be used inside an CompanyUserProvider');
    }
    return context;
};
